import axios, { type AxiosResponse } from 'axios';
import config from 'config';

export const createAiWorkspace = async (): Promise<string> => {
  const { api: { dev: url }, endpoints: { aiWorkspace: { create } } } = config.cognitiveLayer;
  const userId = process.env.REACT_APP_AI_USER_ID || 'test-user';
  const claims = btoa(JSON.stringify({ sub: userId }));
  let response: AxiosResponse;

  try {
    response = await axios.post(
      `${url}${create}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization-Claims': claims,
        },
      },
    );
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status ?? 'network-error';
      console.error(`Failed to create AI workspace (${status})`);
      throw new Error(`Failed to create AI workspace (${status})`);
    }

    throw error;
  }

  // Workspace API contract: payload is always nested under response.data.data.
  const workspacePayload = response.data?.data;
  const workspaceId = workspacePayload?.id ?? workspacePayload?.workspaceId;

  if (!workspaceId) {
    throw new Error('No workspaceId in response');
  }

  console.log(`[createAiWorkspace] Workspace created: ${workspaceId}`);
  return workspaceId;
}